import React from 'react';

import useModal from 'src/components/Modal/useModal';
import { Step } from 'src/types';
import ActionTypeMiniCard from 'src/components/miniCards/ActionTypeMiniCard';
import useGetRequest from 'src/hooks/useGetRequest';
import { EVENT_ATTRIBUTES_BY_EVENT_TYPE } from 'src/constants/constants';
import EmailTemplateBuilderModal from './EmailTemplateBuilderModal';

interface Props {
  step: Step,
  onSuccess: () => void,
}

const EmailBuilder = ({
  step, onSuccess
}: Props) => {
  const {
    isOpen, openModal, closeModal
  } = useModal();

  return (
    <>
      <ActionTypeMiniCard
        // @ts-ignore - step will have an action
        actionType={EVENT_ATTRIBUTES_BY_EVENT_TYPE[step.action.actionType]}
        onClick={() => openModal()}
      />
      {
        isOpen && (
          <EmailTemplateBuilderModal
            onClose={closeModal}
            workflowId={step.workflowId}
            // @ts-ignore - step will have an action
            emailTemplateId={step.action?.emailTemplate.id}
            onSuccess={onSuccess}
          />
        )
      }
    </>
  );
};

export default EmailBuilder;
